<template>
  <v-layout class="d-block px-1 mt-5" v-if="isDataCreated">
    <v-row xs3 class="d-flex align-center mb-5" no-gutters>
      <h3 class="ma-0">Clinic opening defaults</h3>
        <v-tooltip top>
            <template v-slot:activator="{ on }">
                <p style="margin-left: 10px; margin-bottom: 0"><v-icon color="grey" dark v-on="on">mdi-information</v-icon></p>
            </template>
            <p class="tooltip-fixed">Set normal schedule here. Only applies to future dates. To make changes for today - use Today section above</p>
        </v-tooltip>
    </v-row>
    <v-row class="mt-4" no-gutters>
      <v-simple-table class="bordered-table">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center py-3" rowspan="2">Location</th>
              <th class="text-center" colspan="2">Monday</th>
              <th class="text-center" colspan="2">Tuesday</th>
              <th class="text-center" colspan="2">Wednesday</th>
              <th class="text-center" colspan="2">Thursday</th>
              <th class="text-center" colspan="2">Friday</th>
              <th class="text-center" colspan="2">Saturday</th>
              <th class="text-center" colspan="2">Sunday</th>
            </tr>
            <tr>
              <th class="text-center" colspan="2" v-for="i in 7" :key="i">
                <div class="d-flex justify-space-between">
                  <div class="px-2">AM</div>
                  <div class="px-2">PM</div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
          <!--clinic opening defaults-->
          <tr>
            <td>Clinic</td>
            <td class="text-center" colspan="2" v-for="(day, index) in openingDays.clinic" :key="index">
              <div class="d-flex justify-space-between">
                <action-btn v-if="day.am" v-on:change="dayClickHandler(day, 'clinic', 'am')" :isOpen="day.am.isOpen" :isChanged="day.am.changed"></action-btn>
                <action-btn v-else :noData="true" v-on:change="setClinicRotaData(day, 'am')"></action-btn>
                <action-btn v-if="day.pm" v-on:change="dayClickHandler(day, 'clinic', 'pm')" :isOpen="day.pm.isOpen" :isChanged="day.pm.changed"></action-btn>
                <action-btn v-else :noData="true" v-on:change="setClinicRotaData(day, 'pm')"></action-btn>
              </div>
            </td>
          </tr>
          <tr v-for="surgery in openingDays.surgeries" :key="surgery.surgeryId">
            <td>
              {{surgery.surgeryName}}
            </td>
            <td class="text-center" colspan="2" v-for="(day, index) in surgery.days" :key="index">
              <div class="d-flex justify-space-between">
                <action-btn v-if="day.am" v-on:change="dayClickHandler(day, 'surgery', 'am', surgery.id)" :isOpen="day.am.isOpen" :isChanged="day.am.changed"></action-btn>
                <action-btn v-else :noData="true" v-on:change="setSurgeryRotaData(day, 'am', surgery.surgeryId)"></action-btn>
                <action-btn v-if="day.pm" v-on:change="dayClickHandler(day, 'surgery', 'pm', surgery.id)" :isOpen="day.pm.isOpen" :isChanged="day.pm.changed"></action-btn>
                <action-btn v-else :noData="true" v-on:change="setSurgeryRotaData(day, 'pm', surgery.surgeryId)"></action-btn>
              </div>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-row>
  </v-layout>
</template>

<script>

  import { mapActions, mapGetters } from 'vuex'
  import ActionBtn from './ActionBtn'
  import { sortBy } from 'lodash'
  const designators = ['am', 'pm']

  export default {
    name: 'DefaultOpeningDays',
    props: ['clinicId', 'surgeries'],
    data: () => ({
      openingDays: {},
      isDataCreated: false
    }),
    computed: {
      ...mapGetters(['getClinicOpeningDefault'])
    },
    methods: {
      ...mapActions(['fetchClinicOpeningById', 'updateClinicOpening']),
      async createOpeningDaysData () {
        await this.fetchClinicOpeningById(this.clinicId)
        const clinicOpeningDays = this.getClinicOpeningDefault(this.clinicId)
        const clinicData = clinicOpeningDays.filter(dayInfo => !dayInfo.surgeryId)
        const self = this
        this.openingDays = {
          clinic: formatDaysData(clinicData),
          surgeries: this.surgeries.map((surgery) => {
            const surgeriesData = clinicOpeningDays.filter(dayInfo => dayInfo.surgeryId === surgery.id)
            const days = formatDaysData(surgeriesData, surgery.id)
            return {
              surgeryId: surgery.id || surgery.tempId,
              surgeryName: surgery.value,
              days
            }
          })
        }
        this.openingDays.surgeries = sortBy(this.openingDays.surgeries, 'surgeryName')
        this.isDataCreated = true
        function formatDaysData (daysData, surgeryId = null) {
          const daysArray = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
          const data = {}
          daysArray.forEach(day => {
            const filteredByDay = daysData.filter(dayInfo => day.toLowerCase() === dayInfo.dayOfWeek.toLowerCase())
            data[day] = {}
            data[day].am = filteredByDay.find(item => item.designator.toLowerCase() === 'am') || self.createDefaultDayItem(surgeryId, 'am', day, true)
            data[day].pm = filteredByDay.find(item => item.designator.toLowerCase() === 'pm') || self.createDefaultDayItem(surgeryId, 'pm', day, true)
            data[day].none = filteredByDay.find(item => item.none)
            if (!data[day].am || !data[day].pm) {
              data[day].day = day
            }
          })
          return data
        }
      },
      createDefaultDayItem (surgeryId, designator, dayOfWeek, isOpen = true) {
        return {
          clinicId: this.clinicId,
          surgeryId,
          designator: designator.toUpperCase(),
          dayOfWeek,
          isOpen,
          changed: true
        }
      },
      dayClickHandler (item, type, designator, surgeryId) {
        if (type === 'clinic') {
          item[designator].isOpen = !item[designator].isOpen
          if (!item[designator].isOpen) {
            this.openingDays.surgeries.forEach(surgery => {
              const day = Object.keys(surgery.days).find(dayName => dayName === item[designator].dayOfWeek)
              surgery.days[day][designator].isOpen = item[designator].isOpen
              surgery.days[day][designator].changed = true
            })
          }
          item[designator].changed = true
        } else {
          item[designator].isOpen = !item[designator].isOpen
          if (item[designator].isOpen) {
            this.openingDays.clinic[item[designator].dayOfWeek][designator].isOpen = item[designator].isOpen
            this.openingDays.clinic[item[designator].dayOfWeek][designator].changed = true
          }
          item[designator].changed = true
        }
      },
      setClinicRotaData (day, type) {
        day[type] = this.createDefaultDayItem(null, type, day.day)
      },
      setSurgeryRotaData (day, type, id) {
        day[type] = this.createDefaultDayItem(id, type, day.day)
      },
      async saveOpeningDays () {
        const formData = [...convertData(this.openingDays.clinic)]
        this.openingDays.surgeries.forEach(surgery => {
          if (surgery.days) {
            formData.push(...convertData(surgery.days))
          }
        })
        if (formData.length > 0) {
          return this.updateClinicOpening({
            days: formData
          })
        }
        return true
        function convertData (obj) {
          const data = []
          for (const dayInfo of Object.values(obj)) {
            designators.forEach(designator => {
              if (dayInfo[designator] && dayInfo[designator].changed) {
                dayInfo[designator].surgeryId = dayInfo[designator].surgeryId || null
                data.push(dayInfo[designator])
              }
            })
          }
          return data
        }
      }
    },
    components: {
      ActionBtn
    }
  }
</script>
